import { Hero, MarqueeStrip, Philosophy, Divisions, LaserCTA, AssistenzaTeaser, ContactSection } from "@/components/Sections";

export default function HomePage() {
  return (
    <>
      <Hero />
      <MarqueeStrip />
      <Philosophy />
      <Divisions />
      <LaserCTA />
      <AssistenzaTeaser />
      <ContactSection />
    </>
  );
}
